import './setupModules';
import { initializeIcons } from '@fluentui/react/lib/Icons';

initializeIcons();
